import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import classnames from 'classnames'

import { SIGN_UP_SCREENS, IMGIX_CROP_OPTIONS, SCREEN_SIZE_BREAKPOINTS } from '../../constants'
import { useScreenWidth } from '../../hooks/use-screen-width'
import Button from '../button'
import Imgix from '../imgix'
import styles from './html.css'

function HTMLHeader({ isFirstComponent }) {
  const history = useHistory()
  const screenWidth = useScreenWidth()

  const onClickWatchNow = () => {
    history.push('/')
  }

  const onClickSignup = () => {
    // Nav to sign up form
    history.push({
      pathname: SIGN_UP_SCREENS.SIGN_UP.path,
      search: null
    })
  }

  const desktopImageSrc = 'https://lightbox-prod.imgix.net/images/uploads/1778728856647-neon_web_stsa_hero.jpg'
  const mobileImageSrc = 'https://lightbox-prod.imgix.net/images/uploads/1778728943389-neon_mobile_stsa_hero.jpg'
  const isMobileView = screenWidth <= SCREEN_SIZE_BREAKPOINTS.MIN_480
  const imageSrc = isMobileView ? mobileImageSrc : desktopImageSrc

  return (
    <div className={classnames(styles.headerContainer, { [styles.firstComponent]: isFirstComponent })}>
      <div className={styles.headerImageFrame}>
        <Imgix
          src={imageSrc}
          imgixParams={{
            auto: 'format',
            fit: 'crop',
            crop: IMGIX_CROP_OPTIONS.HOTSPOT,
            ar: isMobileView ? '4:3' : '3:1'
          }}
        />
      </div>

      <div className={styles.headerContent}>
        <span className={styles.header}>Here&apos;s something new to stream about</span>
        <div className={styles.subHeaderGroup}>
          <p className={styles.subHeader}>
            Things are changing - in a good way. We&apos;ve given Neon a new look and a fresh lineup, so whether you&apos;re after big drama, easy laughs or the latest cowboy action, we have definitely got something for you to stream about.
          </p>
          <p className={styles.subHeader}>
            We&apos;ve hand-picked big-name series, breakout shows, must-watch movies from the world&apos;s top studios and standout local stories closer to home.
          </p>
          <p className={styles.subHeader}>
            New laughs. New shocks. New favourites. New excuses to stay in... This is Neon, but not as you know it.
          </p>
        </div>
      </div>

      <div className={styles.headerButtonGroup}>
        <Button className={styles.headerButton} onClick={onClickWatchNow}>Stream Now</Button>
        <Button
          className={styles.headerButton}
          darkBGSecondary
          onClick={onClickSignup}
        >
          SIGN UP
        </Button>
      </div>
    </div>
  )
}

HTMLHeader.propTypes = {
  isFirstComponent: PropTypes.bool
}

HTMLHeader.defaultProps = {
  isFirstComponent: false
}

export default HTMLHeader
